import request from '@/utils/request';
const baseUrl = '/rest/channel/pc';
import { upload } from '@/utils/upload';
export const customerUser = {
  //登录，完善，输入口令流程
  sendMessageCode(data) {
    return request.post(`${baseUrl}/customerUser/sendMessageCode`, data);
  },
  verifyImgCode: `${baseUrl}/customerUser/verifyImgCode`,
  verifyLogin(data) {
    return request.post(`${baseUrl}/customerUser/verifyLogin`, data);
  },
  saveCustomerUser(data) {
    return request.post(`${baseUrl}/customerUser/saveCustomerUser`, data);
  },
  channelCommand(data) {
    return request.post(`${baseUrl}/customerUser/channelCommand`, data);
  },
  obtainLoginUser(data) {
    return request.post(`${baseUrl}/customerUser/obtainLoginUser`, data);
  },
  queryWhiteList(data) {
    return request.post(`${baseUrl}/customerUser/queryWhiteList`, data);
  }
};
export const dicBase = {
  provinceList(data) {
    return request.post(`${baseUrl}/dicBase/provinceList`, data);
  },
  cityAreList(data) {
    return request.post(`${baseUrl}/dicBase/cityAreList`, data);
  },
  areaHospitalList(data) {
    return request.post(`${baseUrl}/dicBase/areaHospitalList`, data);
  },
  cityAreaHospitalList(data) {
    return request.post(`${baseUrl}/dicBase/cityAreaHospitalList`, data);
  },
  departmentList(data) {
    return request.post(`${baseUrl}/dicBase/departmentList`, data);
  },
  dutyList(data) {
    return request.post(`${baseUrl}/dicBase/dutyList`, data);
  }
};
export const uploadImage = data => {
  return request.post(`${baseUrl}/upload/image`, data);
};
export const fileUpload = data =>
  upload(`${baseUrl}/upload/fileUpload`, data, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
export const index = {
  channelData(data) {
    return request.post(`${baseUrl}/index/channelData`, data);
  },
  moduleList(data) {
    return request.post(`${baseUrl}/index/moduleList`, data);
  },
  banner(data) {
    return request.post(`${baseUrl}/index/banner`, data);
  },
  informationList(data) {
    return request.post(`${baseUrl}/index/informationList`, data);
  },
  bingliList(data) {
    return request.post(`${baseUrl}/index/bingliList`, data);
  },
  courseList(data) {
    return request.post(`${baseUrl}/index/courseList`, data);
  },
  questionnaireList(data) {
    return request.post(`${baseUrl}/index/questionnaireList`, data);
  }
};
export const questionnaire = {
  questionnaireData(data) {
    return request.post(`${baseUrl}/questionnaire/questionnaireData`, data);
  },
  answerQuestionnaire(data) {
    return request.post(`${baseUrl}/questionnaire/answerQuestionnaire`, data);
  }
};
export const contentManage = {
  courseDetail(data) {
    return request.post(`${baseUrl}/contentManage/courseDetail`, data);
  },
  bingliDetail(data) {
    return request.post(`${baseUrl}/contentManage/bingliDetail`, data);
  },
  informationDetail(data) {
    return request.post(`${baseUrl}/contentManage/informationDetail`, data);
  }
};
// 评论收藏
export const comment = {
  addComment(data) {
    return request.post(`${baseUrl}/contentManage/addComment`, data);
  },
  commentList(data) {
    return request.post(`${baseUrl}/contentManage/commentList`, data);
  },
  topCommentList(data) {
    return request.post(`${baseUrl}/contentManage/topCommentList`, data);
  },
  listDisableUser(data) {
    return request.post(`${baseUrl}/contentManage/listDisableUser`, data);
  },
  userCollect(data) {
    return request.post(`${baseUrl}/collect/userCollect`, data);
  }
};
// 是否签到
export const isSignInAble = data =>
  request.post(`${baseUrl}/contentManage/live/isSignInAble`, data);
// 直播签到
export const signIn = data =>
  request.post(`${baseUrl}/contentManage/live/signIn`, data);
// 积分流水
export const integralList = data =>
  request.post(`${baseUrl}/integral/integralList`, data);
// 收藏列表
export const getUserCollectList = data =>
  request.post(`${baseUrl}/collect/getUserCollectList`, data);
// 获取个人信息
export const userDetail = data =>
  request.post(`${baseUrl}/customerUser/userDetail`, data);
// 更新用户头像
export const updateHeadPhoto = data =>
  request.post(`${baseUrl}/customerUser/updateHeadPhoto`, data);
// 退登
export const logout = data =>
  request.post(`${baseUrl}/customerUser/logout`, data);
// 获取哪些搜索有结果
export const contentSearch = data =>
  request.post(`${baseUrl}/index/contentSearch`, data);
// 获取微信
export const jsApiSignature = data =>
  request.post(`${baseUrl}/wx/jsApiSignature`, data);
// 获取滑动验证码
export const getVerification = data => {
  return new Promise((resolve, reject) => {
    request
      .post(`${baseUrl}/get/verification/imageJson?type=slide`, data)
      .then(res => {
        resolve({ data: res.data });
      });
  });
};
